import * as React from "react";
import style from "./index.module.scss";
import className from "classnames";
import { useState } from "react";
import { ExperimentNavType } from "../../API/navExperiment";
import { Breadcrumb } from "antd";
import ExperimentList from "./components/ExperimentList";
import OrderList from "./components/OrderList";

export default function PageExperimentMain() {
    const [mark, setMark] = useState(ExperimentNavType.allTest);

    return (
        <div className={style.root}>
            <Breadcrumb separator=">" className={style.bread}>
                <Breadcrumb.Item href="/experiment">实验项目</Breadcrumb.Item>
            </Breadcrumb>

            <div className={style.main}>
                <div className={style.nav}>
                    <div
                        className={className(style.title, {
                            [style.active]: mark === ExperimentNavType.allTest
                        })}
                        onClick={() => setMark(ExperimentNavType.allTest)}>
                        全部实验
                    </div>
                    <div
                        className={className(style.title, {
                            [style.active]: mark === ExperimentNavType.myOrder
                        })}
                        onClick={() => setMark(ExperimentNavType.myOrder)}>
                        我的预约
                    </div>
                </div>

                <div className={style.container}>
                    {mark === ExperimentNavType.allTest && <ExperimentList />}
                    {mark === ExperimentNavType.myOrder && <OrderList />}
                </div>
            </div>
        </div>
    );
}
